import Vue from 'vue';
import domHelper from '../scripts/utils/dom-helper';
import GetElSlots from '../scripts/mixins/get-el-slots';

const name = 'hive-popup';
function getDirMatch(direction) {
  /* eslint-disable */
  let dirMatch = direction.match(/((top|bottom|center|left|right)[\s-]*)/gi);
  dirMatch = !dirMatch ? ['top', 'center'] : dirMatch;
  /* eslint-enable */

  if (dirMatch.length === 1) {
    dirMatch[1] = 'center';
  }

  if (
    (dirMatch[0] === 'left' && dirMatch[1] === 'right') ||
    (dirMatch[0] === 'right' && dirMatch[1] === 'left') ||
    (dirMatch[0] === 'top' && dirMatch[1] === 'bottom') ||
    (dirMatch[0] === 'bottom' && dirMatch[1] === 'top')
  ) {
    dirMatch[1] = 'center';
  }

  if (dirMatch[0] === 'center') {
    if (dirMatch[1] === 'center') {
      dirMatch = ['top', 'center'];
    }
    dirMatch.reverse();
  } else if (dirMatch[0] === dirMatch[1]) {
    dirMatch[1] = 'center';
  }
  dirMatch[0] = dirMatch[0].trim();
  dirMatch[1] = dirMatch[1].trim();
  return dirMatch;
}

export default {
  name,
  mixins: [
    GetElSlots,
  ],
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    /**
     * 弹窗方向
     */
    direction: {
      type: String,
      default: 'top center',
    },
    /**
     * 是否显示
     */
    show: Boolean,
    /**
     * 获取弹窗内容宽度
     */
    width: [Number, Function],
    /**
     * 触发方式
     */
    triggerType: {
      validator: val => ['click', 'hover', 'manual'].indexOf(val) > -1,
      default: 'click',
    },
    /**
     * 弹窗 class
     */
    popupClass: [String, Object, Array],
  },

  data() {
    return {
      popupShowed: false,
    };
  },

  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.popupShowed = val;
      },
    },
  },

  render(h) {
    const triggerSlots = this.$scopedSlots.trigger ? this.$scopedSlots.trigger() : null;
    const defaultSlot = this.$scopedSlots.default ? this.$scopedSlots.default() : null;

    this.popupComponent.content = this.popupShowed ? defaultSlot : null;
    this.popupComponent.popupClass = this.popupClass;
    const dirMatch = getDirMatch(this.direction);
    this.popupComponent.dirClass = `hive-popup--p-${dirMatch[0]}-${dirMatch[1]}`;

    for (let i = 0; i < triggerSlots.length; i++) {
      if (triggerSlots[i].tag) {
        return triggerSlots[i];
      }
    }
    return null;
  },

  beforeCreate() {
    this.globalEventBinded = false;
    this.popupElemEventBinded = false;
    this.popupComponent = new Vue({
      parent: this,
      data() { return { content: null, popupClass: '' }; },
      render(h) {
        return this.content ? (
          // appear确保初次渲染的时候依然有过渡动画
          <transition name={`flow-in`} appear={true}>
            <div class={['hive-popup', this.dirClass, this.popupClass]}>
              {this.content}
            </div>
          </transition>
        ) : null;
      },
    });
    this.popupComponent.$mount();
  },

  mounted() {
    this.triggerElem = this.$el;
    if (this.triggerElem) {
      if (this.triggerType === 'click') {
        this.triggerElem.addEventListener('click', this.onClick);
      }
      if (this.triggerType === 'hover') {
        this.triggerElem.addEventListener('mouseenter', this.onMouseenter);
        this.triggerElem.addEventListener('mouseleave', this.onMouseleave);
      }
    }
    this.afterRender();
  },

  updated() {
    this.afterRender();
  },

  beforeDestroy() {
    this.unbindGlobalEvent();
    try {
      document.body.removeChild(this.popupComponent.$el);
    } catch (e) { }
    this.popupComponent.$destroy();
  },

  methods: {
    afterRender() {
      if (this.popupShowed) {
        this.bindPopupElemEvent();
        if (this.triggerType === 'click' || this.triggerType === 'manual') {
          this.bindGlobalEvent();
        }
        this.dirMatch = getDirMatch(this.direction);
        this.$nextTick(function() {
          this.setPopupPosition();
        });
      } else {
        this.unbindGlobalEvent();
        this.unbindPopupElemEvent();
      }
    },

    bindPopupElemEvent() {
      if (!this.popupElemEventBinded) {
        if (this.triggerType === 'hover') {
          this.popupComponent.$el.addEventListener('mouseenter', this.onMouseenter);
          this.popupComponent.$el.addEventListener('mouseleave', this.onMouseleave);
        }
      }
    },

    unbindPopupElemEvent() {
      if (this.popupComponent.$el) {
        this.popupComponent.$el.removeEventListener('mouseenter', this.onMouseenter);
        this.popupComponent.$el.addEventListener('mouseleave', this.onMouseleave);
      }
    },

    bindGlobalEvent() {
      if (!this.globalEventBinded) {
        this.globalEventBinded = true;
        window.addEventListener('resize', this.debouceSetPopupPostion);
        window.addEventListener('scroll', this.debouceSetPopupPostion);
        document.addEventListener('click', this.onClickOutside);
      }
    },

    unbindGlobalEvent() {
      this.globalEventBinded = false;
      window.removeEventListener('resize', this.debouceSetPopupPostion);
      window.removeEventListener('scroll', this.debouceSetPopupPostion);
      document.removeEventListener('click', this.onClickOutside);
    },

    setPopupPosition() {
      this.popupElem = this.popupComponent.$el;
      document.body.appendChild(this.popupComponent.$el);

      const show = this.popupShowed;
      const padding = 0;
      const dirMatch = [...this.dirMatch];
      // const padding = 16;
      const triggerElem = this.triggerElem;

      // console.log('setPopupPosition', triggerElem, this.popupElem);
      if (!show || !triggerElem || !this.popupElem || triggerElem.nodeType !== 1 || this.popupElem.nodeType !== 1) {
        return;
      }

      const winHeight = window.innerHeight;
      const winWidth = window.innerWidth;
      const triggerElemRect = triggerElem.getBoundingClientRect();
      const popupElemRect = this.popupElem.getBoundingClientRect();
      const popupStyle = {};

      if (typeof this.width !== 'undefined') {
        const width = this.width;
        let w;
        if (typeof width === 'function') {
          w = width(triggerElem);
        } else {
          w = width;
        }
        popupElemRect.width = w + padding * 2;
        popupStyle.width = w + padding * 2;
      }

      // If there is not enough space in the specified direction, set it to the opposite direction
      if (dirMatch[0] === 'top' && popupElemRect.height > triggerElemRect.top) {
        dirMatch[0] = 'bottom';
      }
      if (dirMatch[0] === 'bottom' && popupElemRect.height > winHeight - triggerElemRect.top - triggerElemRect.height) {
        dirMatch[0] = 'top';
      }
      if (dirMatch[0] === 'left' && popupElemRect.width > triggerElemRect.left) {
        dirMatch[0] = 'right';
      }
      if (dirMatch[0] === 'right' && popupElemRect.width > winWidth - triggerElemRect.left - triggerElemRect.width) {
        dirMatch[0] = 'left';
      }

      // style
      if (dirMatch[0] === 'top') {
        popupStyle.top = triggerElemRect.top - popupElemRect.height;
      } else if (dirMatch[0] === 'bottom') {
        popupStyle.top = triggerElemRect.top + triggerElemRect.height;
      } else if (dirMatch[0] === 'left') {
        popupStyle.left = triggerElemRect.left - popupElemRect.width;
      } else if (dirMatch[0] === 'right') {
        popupStyle.left = triggerElemRect.left + triggerElemRect.width;
      }

      if (dirMatch[1] === 'top') {
        popupStyle.top = triggerElemRect.top - padding;
      } else if (dirMatch[1] === 'bottom') {
        popupStyle.top = triggerElemRect.top + triggerElemRect.height - popupElemRect.height + padding;
      } else if (dirMatch[1] === 'left') {
        popupStyle.left = triggerElemRect.left - padding;
      } else if (dirMatch[1] === 'right') {
        popupStyle.left = triggerElemRect.left + triggerElemRect.width - popupElemRect.width + padding;
      } else {
        /* eslint-disable */
        // center
        if (dirMatch[0] === 'top' || dirMatch[0] === 'bottom') {
          popupStyle.left = triggerElemRect.left - (popupElemRect.width - triggerElemRect.width) / 2;
        } else {
          popupStyle.top = triggerElemRect.top - (popupElemRect.height - triggerElemRect.height) / 2;

        }
        /* eslint-enable */
      }

      if (dirMatch[0] === 'top') {
        popupStyle.top = triggerElemRect.top - popupElemRect.height;
      } else if (dirMatch[0] === 'bottom') {
        popupStyle.top = triggerElemRect.top + triggerElemRect.height;
      } else if (dirMatch[0] === 'center') {
        popupStyle.top = triggerElemRect.top - (popupElemRect.height - triggerElemRect.height) / 2;
      }

      popupStyle.top += window.scrollY || window.pageYOffset;
      popupStyle.left += window.scrollX || window.pageXOffset;

      domHelper.css(this.popupElem, popupStyle);

      // class for style arrow
      this.popupElem.className = this.popupElem.className.replace(/hive-popup--p-[\w-]+/g, '').replace(/\s+/g, ' ');

      this.popupElem.classList.add(`hive-popup--p-${dirMatch[0]}-${dirMatch[1]}`);
    },

    onClick() {
      this.togglePopup();
    },

    onMouseenter() {
      clearTimeout(this.mouseleaveT);
      this.showPopup();
    },

    onMouseleave() {
      this.mouseleaveT = setTimeout(() => {
        this.hidePopup();
      }, 50);
    },

    onClickOutside(e) {
      if (
        !this.popupShowed ||
        domHelper.contains(this.popupElem, e.target) ||
        domHelper.contains(this.triggerElem, e.target)
      ) {
        return;
      }
      this.hidePopup();
    },

    togglePopup() {
      this.popupShowed ? this.hidePopup() : this.showPopup();
    },

    showPopup() {
      if (this.triggerType !== 'manual') {
        this.popupShowed = true;
      }
      /**
       * 弹窗显示变换回调
       */
      this.$emit('change', true);
    },

    hidePopup() {
      if (this.triggerType !== 'manual') {
        this.popupShowed = false;
      }
      /**
       * 弹窗显示变换回调
       * @param {Boolean} visible
       */
      this.$emit('change', false);
    },
  },
};
